import React, { useEffect, useState, useCallback, useMemo } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { RootReducerState } from 'types/global'
import { NotificationAction, NotificationReducer } from 'types/notification'
import NotificationActions from 'actions/Notification'
import { Dispatch } from 'redux'
import {
    TitleForm,
    MainForm,
    Top,
    TopInputs,
    ContainerForm,
    SubtitleForm,
} from 'pages/NotificationTreatment/NotificationsTreatmentsSteps/LondonProtocol/styles'
import { useForm } from 'react-hook-form'
import NotificationService from 'services/Notification'
import { BackButton, SaveButton } from '../../styles'
import { Breadcrumbs, SecondTextBreadcrumbs } from '../../../Header/styles'
import { WarningModal } from 'components/Modals/WarningModal'
import { AiOutlineExclamationCircle } from 'react-icons/ai'
import { useCallbackPrompt } from 'hooks/useCallbackPrompt'
import { setStartedDataV3 } from '../../helper'
import { LondonProtocolFormFieldsBodyV3 } from './LondonProtocolFormFieldsBodyV3'
import { VariableAction, VariableReducer } from 'types/variable'
import VariableActions from 'actions/Variable'
import { getVarible } from 'utils/variblesHandler'
import { notificationStatus } from 'constants/notificationStatus'
import { IAuthenticationReducer } from 'types/autentication'
import { Beforeunload } from 'react-beforeunload'
import { calculateObjectProbabilityOcurrence } from 'pages/NotificationTreatment/helpers'
import { canEditLondonProtocol } from '../..'
import DefaultModal from 'components/Modals'
import DataLondonProtocolInfoModal from 'pages/NotifyEvent/components/modals/DataLondonProtocolInfoModal'
import { listOfRoles } from 'components/WithRoleAuthorization/WithRoleAuthorization'

/**
 * Formulário principal para edição das informações do LONDON PROTOCOL layout v3
 */
const FormLondonProtocolV3: React.FC = () => {
    const LONDON_PROTOCOL_VERSION = 'v3'
    const { id } = useParams()
    const { register, control, watch, handleSubmit, formState: { errors, dirtyFields }, setValue, getValues } = useForm();

    const navigate = useNavigate()
    const [notAllowed, setNotAllowed] = useState(false)
    const [showModal, setShowModal] = useState(false)
    const [statusIsArchivedOrFinished, setStatusIsArchivedOrFinished] = useState(false)
    const [manualDirty, setManualDirty] = useState(false)
    const [notificationStatusState, setNotificationStatusState] = useState('')
    const [typesOfDiagnosis, setTypesOfDiagnosis] = useState([]);
    const [sentinelEvent, setSentinelEvent] = useState([]);
    const [neverEvents, setNeverEvents] = useState([]);
    const [omsClassifications, setOmsClassifications] = useState([])
    const [isSaving, setIsSaving] = useState(false)
    const notificationSelector: NotificationReducer = useSelector((state: RootReducerState) => state.notificationsReducer)
    const notificationDispatch: Dispatch<NotificationAction> = useDispatch()
    const variableDispatch: Dispatch<VariableAction> = useDispatch()

    const notification = useMemo(() => notificationSelector?.notificationById, [notificationSelector?.notificationById])
    const protocoloLondon = useMemo(() => notificationSelector?.londonProtocol, [notificationSelector?.londonProtocol])

    const protocoloNotificationFactors = useMemo(() => {
        const keys = Object.keys(notificationSelector?.factors || {});
        let response: Record<string, any[]> = {};
        keys.forEach(k => {
            response[k] = notificationSelector?.factors?.[k]?.filter(
                f => f?.u_category_factors_version === LONDON_PROTOCOL_VERSION
            ) || [];
        });
        return response;
    }, [notificationSelector?.factors, notificationSelector?.londonProtocol]);

    const londonVaribles = useMemo(() => notificationSelector?.londonVaribles, [notificationSelector?.londonVaribles])
    const chronologicalReportValue: string = watch('chronological_report') || ''

    const variableSelector: VariableReducer = useSelector(
        (state: RootReducerState) => state.variableReducers
    )

    const auth: IAuthenticationReducer = useSelector(
        (state: RootReducerState) => state.authenticationReducers
    )
    const currentUser = useMemo(() => {
        return auth.dataJwt
    }, [auth])

    const isSameLocation = useMemo(() => {
        return currentUser?.locations && currentUser?.locations?.filter((i) => i.sys_id === notificationSelector.notificationById?.location_incident?.value).length > 0
    }, [currentUser, notificationSelector.notificationById])

    const isSameSector = useMemo(() => {
        return currentUser?.locations && currentUser?.locations?.filter((i) => i.sys_id === notificationSelector.notificationById?.location_incident?.value)[0]?.sectors.filter((i) => i.sys_id === notificationSelector.notificationById?.incident_sector?.value).length > 0
    }, [currentUser, notificationSelector.notificationById])

    const loggedInUserIsResponsible = useMemo(() => {
        return currentUser?.sys_id && currentUser?.sys_id ===
            notificationSelector.notificationById?.u_assigned_to?.value
    }, [currentUser, notificationSelector.notificationById])

    useEffect(() => {
        if (canEditLondonProtocol({ loggedInUserIsResponsible, isSameLocation, isSameSector, notificationStatusState })
            .includes(currentUser?.profile) && !statusIsArchivedOrFinished) {
            setNotAllowed(false)
        } else {
            setNotAllowed(true)
        }
    }, [loggedInUserIsResponsible, isSameLocation, isSameSector, notificationStatusState, statusIsArchivedOrFinished])
    //set data
    useEffect(() => {
        if (protocoloLondon) {
            setStartedDataV3({ setValue, data: protocoloLondon })
        }

    }, [protocoloLondon])

    useEffect(() => {
        if (notificationSelector?.notificationById?.u_state) {
            setNotificationStatusState(
                notificationSelector?.notificationById?.u_state.display_value
            )
        }
    }, [notificationSelector.notificationById])

    useEffect(() => {
        if (notificationStatusState) {
            const allowed = [notificationStatus[4].label, notificationStatus[5].label]
            const satus = allowed.includes(notificationStatusState)
            setStatusIsArchivedOrFinished(satus)
        }
    }, [notificationStatusState])

    useEffect(() => {
        VariableActions.getAllVariables(variableDispatch)
    }, [])

    useEffect(() => {
        NotificationActions.getNotificationLondonVaribles(notificationDispatch);
        NotificationActions.getNotificationFactors(notificationDispatch);
        NotificationActions.getTypesOfDiagnosis(notificationDispatch);
        NotificationActions.getNotificationById(notificationDispatch, id)
        NotificationActions.getLondonProtocolByNotificationId(notificationDispatch, id)
    }, [])

    useEffect(() => {
        if (variableSelector.variablesList) {
            const varible = getVarible(
                variableSelector.variablesList,
                'containerType',
                'container'
            )
            if (varible?.children) {
                const omsChoices = getVarible(
                    varible?.children,
                    'name',
                    'u_oms_classification'
                )

                setOmsClassifications(omsChoices?.choices)
            }
        }
    }, [variableSelector])

    useEffect(() => {
        if (notificationSelector.typesOfDiagnosis) {
            const typesOfDiagnosisFlat = notificationSelector.typesOfDiagnosis[0]?.result.flat()
            let typesOfDiagnosis = typesOfDiagnosisFlat?.map((item, index) => ({
                label: item.description,
                value: item.sys_id
            })).sort((o1, o2) => o1.label?.localeCompare(o2.label));
            setTypesOfDiagnosis(typesOfDiagnosis)
        }
    }, [notificationSelector.typesOfDiagnosis])

    useEffect(() => {
        if (notificationSelector.sentinelEvent && notification) {
            const notificationVersion = notification?.u_version?.value || process.env.REACT_APP_NOTIFICATION_VERSION
            const flat = notificationSelector.sentinelEvent
            const customSentinel = flat?.filter(item => item?.u_version == notificationVersion)?.map((item, index) => ({
                label: item.description,
                value: item.sys_id
            })).sort((o1, o2) => o1.label?.localeCompare(o2.label))
            setSentinelEvent(customSentinel.slice(14, 15)
                .concat(customSentinel.slice(0, 14)
                    .concat(customSentinel.slice(15))))

        }
    }, [notificationSelector.sentinelEvent, notification?.u_version?.value])


    useEffect(() => {
        if (notificationSelector.neverEvents && notification) {
            const notificationVersion = notification?.u_version?.value || process.env.REACT_APP_NOTIFICATION_VERSION
            const flat = notificationSelector.neverEvents;
            const neverEventss = flat?.filter(item => item?.u_version == notificationVersion || item?.sys_id == 'not_applicable')?.map((item, index) => ({
                label: item.u_description || item.label,
                value: item.sys_id || item.id
            }))

            setNeverEvents(neverEventss)
        }
    }, [notificationSelector.neverEvents, notification?.u_version?.value])

    const getTreatmentNumber = () => {
        if (notificationSelector?.notificationById) {
            if (notificationSelector?.notificationById.document_type?.value === 'atendimento') {
                if (protocoloLondon?.u_patient_care_number) {
                    return protocoloLondon?.u_patient_care_number;
                }
                return notificationSelector?.notificationById?.document_number?.value
            }
        }
    }

    const handleSubmitForm = (data) => {
        setIsSaving(true)

        const neverEventsSelected = neverEvents?.filter(e => e.value === data.u_never_events)
            .map(e => ({
                display_value: e.label,
                value: e.value
            }));
        notificationSelector.notificationById.u_never_events = neverEventsSelected[0];
        
        const LondonProtocolSN = {
            ...data,
            ...(protocoloLondon?.sys_id ? { sys_id: protocoloLondon?.sys_id } : {}),
            hospital_incident: id,
            u_version: LONDON_PROTOCOL_VERSION,
        }

        NotificationService.saveLondonProtocol(LondonProtocolSN, notificationSelector.notificationById).then((response: any) => {
            let notification = notificationSelector.notificationById
            let notificationProcessRequiredStepsRules = calculateObjectProbabilityOcurrence(notification)
            notificationProcessRequiredStepsRules.currentStepSelected = 3
            NotificationActions.defineObjectNotificationProcessRequiredStepsRules(notificationDispatch, notificationProcessRequiredStepsRules)
            navigate(`/notificacoes/${id}`, { state: { currentStep: 3, messageSuccess: 'Protocolo de Londres salvo com sucesso!' } })
        }).catch((error) => {
            console.log(error)
        }).finally(() => {
            setIsSaving(false)
        })
    }

    const backToLondonProtocol = useCallback((e: any) => {
        navigate(`/notificacoes/${id}`, { state: { currentStep: 3 } })
    }, [])

    const isDirty = !!Object.keys(dirtyFields).length || manualDirty
    const [showPrompt, confirmNavigation, cancelNavigation] =
        useCallbackPrompt(isDirty && !isSaving)

    const organizationalConsequences = useMemo(() => {
        const organizationalConsequences = londonVaribles?.organizational_consequences.slice(5, 6)
            .concat(londonVaribles?.organizational_consequences.slice(0, 5)
                .concat(londonVaribles?.organizational_consequences.slice(6)))
        return organizationalConsequences
    }, [londonVaribles?.organizational_consequences])

    const onChangeHelper = () => {
        setManualDirty(true)
    }


    const getSentinelEvent = useMemo(() => {
        if(notificationSelector?.sentinelEvent && notification){
            const notificationVersion = notification?.u_version?.value || process.env.REACT_APP_NOTIFICATION_VERSION
            const sentinelEventValue = notificationSelector.notificationById?.u_sentinel_event_jci?.value;
            const [sentinelEvent] = notificationSelector?.sentinelEvent?.filter(se => se?.u_version === notificationVersion)
                .filter(se => se?.sys_id == sentinelEventValue)
            return sentinelEvent?.description || "-";
        }

        return "-";
    }, [id, notification?.u_version?.value])


    const getNeverEvent = useMemo(() => {
        if (notificationSelector?.neverEvents && notification) {
            const notificationVersion = notification?.u_version?.value || process.env.REACT_APP_NOTIFICATION_VERSION
            const neverEventsReference = notificationSelector.notificationById?.u_never_events_reference?.value;
            const [neverEvent] = notificationSelector?.neverEvents?.filter(se => se?.u_version === notificationVersion)
                .filter(se => se?.sys_id == neverEventsReference)
            return neverEvent?.u_description || "-";
        }
        return "-";
    }, [id, notification?.u_version?.value])


    const onlyProfilecanInputNSPOpinion = useMemo(() => {
        return [listOfRoles.admin, listOfRoles.location_qa].includes(currentUser?.profile)
    }, [currentUser])

    return (
        <>
            {isDirty && (
                <Beforeunload onBeforeunload={(event) => 'Você fez edições que não forma salvas.'} />
            )}
            <WarningModal
                icon={
                    <AiOutlineExclamationCircle
                        size={50}
                        className="text-yellow"
                    />
                }
                customStyle={{
                    titleStyle: 'text-yellow'
                }}
                title="Edição não salva"
                subTitle="Você fez edições que não foram salvas. Se sair, você perderá as edições."
                leftButtonAction={confirmNavigation as () => void}
                rightButtonAction={cancelNavigation as () => void}
                isOpen={showPrompt as boolean}
                handleCloseModal={cancelNavigation as () => void}
                leftButtonText="Sair"
                rightButtonText="Continuar edição"
            />
            <DefaultModal
                isOpen={showModal}
                handleCloseModal={() => {
                    setShowModal(false)
                }}
                children={<DataLondonProtocolInfoModal
                    close={() => {
                        setShowModal(false)
                    }}
                />}
            />


            <ContainerForm data-testid="test-step3-from">
                <MainForm onSubmit={handleSubmit(handleSubmitForm)}>
                    <div className='flex items-baseline mt-8 justify-between'>
                        <Breadcrumbs>
                            <Link className="mr-1 cursor-pointer" to="/notificacoes">
                                Gestão das notificações
                            </Link>
                            {' > '}
                            <SecondTextBreadcrumbs className="mr-1 cursor-pointer" onClick={backToLondonProtocol}>
                                Notificações
                            </SecondTextBreadcrumbs>
                            {' > '}
                            <SecondTextBreadcrumbs>Protocolo de Londres</SecondTextBreadcrumbs>
                        </Breadcrumbs>
                        <TopInputs>
                            <BackButton type='button' onClick={backToLondonProtocol}>Voltar</BackButton>
                            <SaveButton type='submit' disabled={!isDirty} className={!isDirty ? 'bg-disabled' : ''}>Salvar</SaveButton>
                        </TopInputs>
                    </div>
                    <fieldset disabled={notAllowed}>
                        <div className='overflow-y-auto'>
                            <Top>
                                <div>
                                    <TitleForm data-testid='notifications'> Preencher Protocolo de Londres </TitleForm>
                                    <SubtitleForm>Identifique os detalhes que levaram o incidente acontecer, e preencha abaixo as informações:</SubtitleForm>
                                </div>

                            </Top>
                            <hr />
                            <LondonProtocolFormFieldsBodyV3
                                register={register}
                                control={control}
                                setValue={setValue}
                                getValues={getValues}
                                errors={errors}
                                notification={notification}
                                notificationSelector={notificationSelector}
                                protocoloLondon={protocoloLondon}
                                protocoloNotificationFactors={protocoloNotificationFactors}
                                londonVaribles={londonVaribles}
                                typesOfDiagnosis={typesOfDiagnosis}
                                organizationalConsequences={organizationalConsequences}
                                chronologicalReportValue={chronologicalReportValue}
                                onChangeHelper={onChangeHelper}
                                notAllowed={notAllowed}
                                getTreatmentNumber={getTreatmentNumber}
                                neverEventDisplay={getNeverEvent}
                                sentinelEventDisplay={getSentinelEvent}
                                omsClassifications={omsClassifications}
                                setShowModal={setShowModal}
                                onlyProfilecanInputNSPOpinion={onlyProfilecanInputNSPOpinion}
                                context="individual"
                            />
                        </div>
                    </fieldset>
                </MainForm>
            </ContainerForm>
        </>
    )
}

export { FormLondonProtocolV3 }
